import { api } from '@/services';
import Vue from 'vue';
import Vuetify from '@/plugins/vuetify';

function buildURLSearchParams(payload) {
  const params = new URLSearchParams();

  Object.keys(payload).forEach((key) => {
    const value = payload[key];
    if (Array.isArray(value)) {
      params.append(key, value.join(','));
    } else if (typeof value === 'object' && value !== null) {
      Object.keys(value).forEach((subKey) => {
        params.append(`${key}${subKey.charAt(0).toUpperCase() + subKey.slice(1)}`, value[subKey]);
      });
    } else if (value) {
      params.append(key, value);
    }
  });

  return params;
}

function buildURLFormData(data, arquivos) {
  const params = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    params.append(key, value);
  });

  if (arquivos && Array.isArray(arquivos)) {
    Object.entries(arquivos).forEach(([, value]) => {
      if (value.file) {
        params.append('arquivos', value.file);
      } else {
        const jsonValue = JSON.stringify(value);
        params.append('documentos[]', jsonValue);
      }
    });
  }

  return params;
}

export default {
  async fetchNoticiasClientesItems({ commit, dispatch }, payload) {
    const params = buildURLSearchParams(payload);

    dispatch('toggleLoading', true, { root: true });

    const { data } = await api.get('/noticiasClientes', { params });

    const parsedData = data.map((infoDist) => ({
      id: infoDist._id,
      titulo: infoDist.titulo,
      status: infoDist.status,
      enviarPara: infoDist.enviarPara,
      dataEnvio: infoDist.dataEnvio,
      horario: infoDist.horario,
    }));

    commit('SET_NOTICIAS_CLIENTES_TABLE_ITEMS', parsedData);
    commit('paginacao/SET_PAGINADOR', data, { root: true });

    dispatch('toggleLoading', false, { root: true });
  },
  async fetchGruposPessoas({ commit }) {
    const { data } = await api.get('/noticiasClientes/grupos');

    commit('SET_GRUPO_PESSOAS', data);
  },
  async getNoticiaClientes({ dispatch }, payload) {
    const { id } = payload;

    try {
      const { data } = await api.get(`/noticiasClientes/find/${id}`);

      dispatch('setCriarEnvioForm', data);
    } catch (e) {
      const { response } = e;

      Vue.$toast.clear();
      Vue.$toast.error(response.data.message);
    }
  },
  async createNoticiaClientes({ getters, dispatch }, payload) {
    const { arquivos, ...data } = payload;

    try {
      const params = buildURLFormData(data, arquivos);

      await api.post('/noticiasClientes', params, {
        headers: {
          'Content-Type': 'multiform/form-data',
        },
      });

      Vue.$toast.success(Vuetify.framework.lang.t('$vuetify.noticiaCriada'));

      dispatch('fetchNoticiasClientesItems', getters.getFiltros);
    } catch (e) {
      const { response } = e;

      Vue.$toast.clear();
      Vue.$toast.error(response.data.message);
    }
  },
  async enviarAgora({ getters, dispatch }, payload) {
    const { arquivos, ...data } = payload;

    try {
      const params = buildURLFormData(data, arquivos);

      await api.post('/noticiasClientes/enviarAgora', params, {
        headers: {
          'Content-Type': 'multiform/form-data',
        },
      });

      Vue.$toast.success(Vuetify.framework.lang.t('$vuetify.noticiaCriada'));

      dispatch('fetchNoticiasClientesItems', getters.getFiltros);
    } catch (e) {
      const { response } = e;

      Vue.$toast.clear();
      Vue.$toast.error(response.data.message);
    }
  },
  async updateNoticiaClientes({ getters, dispatch }, payload) {
    delete payload.usuarioId;
    delete payload.__v;
    delete payload.createdAt;
    delete payload.updatedAt;

    const { _id, arquivos, ...data } = payload;

    try {
      const params = buildURLFormData(data, arquivos);

      await api.put(`/noticiasClientes/${_id}`, params, {
        headers: {
          'Content-Type': 'multiform/form-data',
        },
      });

      Vue.$toast.success(Vuetify.framework.lang.t('$vuetify.noticiaAtualizada'));

      dispatch('fetchNoticiasClientesItems', getters.getFiltros);
    } catch (e) {
      const { response } = e;

      Vue.$toast.clear();
      Vue.$toast.error(response.data.message);
    }
  },
  async removeNoticiaClientes({ getters, dispatch }, payload) {
    const { id } = payload;

    try {
      await api.delete(`/noticiasClientes/${id}`);

      Vue.$toast.success(Vuetify.framework.lang.t('$vuetify.noticiaApagada'));

      dispatch('fetchNoticiasClientesItems', getters.getFiltros);
    } catch (e) {
      const { response } = e;

      Vue.$toast.clear();
      Vue.$toast.error(response.data.message);
    }
  },
  async setCriarEnvioForm({ commit }, payload) {
    commit('SET_CRIAR_ENVIO_FORM', payload);
  },
  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },
};
